import Link from 'next/link'

const FooterLinksForm = () => {
  return (
    <div className='space-x-4  pb-8 pt-10 text-center lg:flex lg:pb-16 lg:text-left'>
      <Link href='https://consensys.net/privacy-policy/' legacyBehavior passHref>
        <a className='font-medium' rel='noopener noreferrer' target='_blank'>
          Privacy Policy
        </a>
      </Link>
      <Link className='font-medium' href='https://consensys.net/terms-of-use/' legacyBehavior passHref>
        <a className='font-medium' rel='noopener noreferrer' target='_blank'>
          Terms of Use
        </a>
      </Link>
    </div>
  )
}

export default FooterLinksForm
